import React from 'react';
import '../UploadForm.css';
import Tooltip from '../common/Tooltip.js';

function UploadedResumeSummary({ files, editedFlags, disabled = false }) {
  if (!files || files.length === 0) return null;
  return (
    <Tooltip
      content={
        <div style={{ padding: '4px', maxHeight: '200px', overflowY: 'auto' }}>
          {files.map((file, index) => (
            <div key={index} style={{ whiteSpace: 'nowrap' }}>
              #{files.indexOf(file) + 1}: {editedFlags[index] ? file.name.replace(/\.[^/.]+$/, '') : file.name}
            </div>
          ))}
        </div>
      }
      position="top"
      delay={100}
      verticalOffset={5}
      triggerClassName="uploaded-resume-summary"
    >
      <div id="uploaded-resume-summary" aria-disabled={disabled}>
        {files.length} file{files.length !== 1 ? 's' : ''} selected
      </div>
    </Tooltip>
  );
}

export default UploadedResumeSummary;


